import { apiClient } from '../config/api';

// FEAT-065 admin client (MVP-18.7).

export interface PremiumPlacementAdminView {
  id: string;
  caregiverId: string;
  caregiverName: string;
  zip: string;
  regionName: string | null;
  expiresAt: string;
}

interface PremiumPlacementsResponse {
  success: boolean;
  data: PremiumPlacementAdminView[];
}

class PremiumPlacementsAdminService {
  async listActive(): Promise<PremiumPlacementAdminView[]> {
    const response = await apiClient.get<PremiumPlacementsResponse>(
      '/admin/premium-placements',
    );
    if (!response.data.success) {
      throw new Error('Failed to load premium placements');
    }
    return response.data.data;
  }
}

export const premiumPlacementsAdminService = new PremiumPlacementsAdminService();
